import { ServiceTag } from '../../models/interfaces/ServiceTag.interface';

export class ServiceTagUtils {
  public static isTreatmentCategory(serviceTag: ServiceTag): boolean {
    const regexToCheckCategory = new RegExp('^--.*--$');
    return regexToCheckCategory.test(serviceTag.tag);
  }
}
